import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EnergyEfficiencyDTO, WellDetailsDTO } from 'types/indicators';

export type EnergyEfficiencyState = {
  energyEfficiencyData: EnergyEfficiencyDTO[];
  filteredEnergyEfficiencyData: EnergyEfficiencyDTO[];
  wellDetailsData: WellDetailsDTO[];
  totalItems: number;
};

export const initialState: EnergyEfficiencyState = {
  energyEfficiencyData: [],
  filteredEnergyEfficiencyData: [],
  wellDetailsData: [],
  totalItems: 0,
};

const EnergyEfficiencySlice = createSlice({
  name: 'EnergyEfficiency',
  initialState,
  reducers: {
    updateEnergyEfficiencyData: (
      state = initialState,
      action: PayloadAction<EnergyEfficiencyDTO[]>,
    ) => {
      state.energyEfficiencyData = [...action.payload];
    },
    updateFilteredEnergyEfficiencyData: (
      state = initialState,
      action: PayloadAction<EnergyEfficiencyDTO[]>,
    ) => {
      state.filteredEnergyEfficiencyData = [...action.payload];
    },
    updateWellDetailsData: (state = initialState, action: PayloadAction<WellDetailsDTO[]>) => {
      state.wellDetailsData = [...action.payload];
    },
  },
});

export const { actions, reducer } = EnergyEfficiencySlice;
export const {
  updateEnergyEfficiencyData,
  updateFilteredEnergyEfficiencyData,
  updateWellDetailsData,
} = actions;

export default reducer;
